import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Routes from "../../config/Routes";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import Loadable from "react-loading-overlay";
import { Grid } from "react-bootstrap";

class Body extends Component {
  render() {
    // const rutas = {
    //   home: { name: "Home", path: "/" },
    //   events: { name: "Eventos", path: "/events" },
    //   tickets: { name: "Tickets", path: "/events/tickets" },
    //   users: { name: "Usuarios", path: "/users" },

    // };
 
    return (
      // <div style={{ height: "100%", overflow:"scroll", backgroundColor:"blue" }}>
      //    {this.props.login ? (
      //     <Breadcrumb
      //       routesInfo={rutas}
      //       path={window.location.pathname}
      //       separatorStyle={{ color: "#1bb6b1" }}
      //     />
      //   ) : null}
      <div style={this.props.style}>  
          <Routes />
      </div>
    );
  }
}
function mapStateToProps(store) {
  return {
    login: store.auth.login,
    loading: store.app.loading
  };
}

export default withRouter(connect(mapStateToProps)(Body));



// WEBPACK FOOTER //
// ./src/components/Body/Body.js